import { foundations } from '../foundations';
const { colors, shadows } = foundations;

export const Select = {
  baseStyle: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
    color: colors.text.base[colorMode],
    _disabled: {
      color: colors.text.tertiary[colorMode],
    },
    _placeholder: {
      color: colors.text.secondary[colorMode],
    },
  }),
  sizes: {
    xs: {
      field: {
        fontSize: '0.75rem',
      },
    },
  },
  variants: {
    outline: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      borderRadius: '0.325rem',
      bg: colors.background.form.default[colorMode],
      border: `1px solid ${colors.border.form.default[colorMode]}`,
      _hover: {
        borderColor: colors.border.form.hover[colorMode],
        shadow: 'none',
      },
      _focus: {
        borderColor: colors.border.form.focus,
        shadow: shadows.outline,
      },
      _invalid: {
        borderColor: colors.border.form.critical[colorMode],
        shadow: 'none',
      },
      _disabled: {
        bg: colors.background.form.disabled[colorMode],
        border: `1px solid ${colors.border.form.default[colorMode]}`,
      },
    }),
  },
};
